import Icon from '../Icon';
import {formatDateShort, formatTime, todayLocal} from '../../lib/when';

// The "When" row: looks like a fact row, is a native datetime-local input underneath so the
// phone's own picker does the work. Defaults to now; editable for back-filling.
type Props = {value: string; onChange: (whenLocal: string) => void};

export default function WhenRow({value, onChange}: Props) {
    const day = value.slice(0, 10) === todayLocal() ? 'Today' : formatDateShort(value);
    return (
        <label className="relative flex min-h-[52px] cursor-pointer items-center gap-3 rounded-md border-[1.5px] border-line bg-surface px-4">
            <Icon name="calendar" size={20} className="shrink-0 text-ink-2" />
            <span className="flex-1 font-semibold">
                {day}, {formatTime(value.length >= 16 ? value : `${value}:00`)}
            </span>
            <Icon name="chevron" size={20} className="text-ink-3" />
            <input
                type="datetime-local"
                className="absolute inset-0 cursor-pointer opacity-0"
                value={value.slice(0, 16)}
                max={`${todayLocal()}T23:59`}
                onChange={e => e.target.value && onChange(e.target.value)}
                aria-label="When"
            />
        </label>
    );
}
